export default __webpack_public_path__ + "static/media/Avatar-27.46214f6d.png";